import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface SystemStatusCardProps {
  service: string;
  status: 'healthy' | 'warning' | 'error' | 'offline';
  uptime: string;
  responseTime: string;
}

const statusConfig = {
  healthy: {
    color: 'bg-green-500',
    badge: 'default',
    text: 'Healthy'
  },
  warning: {
    color: 'bg-yellow-500',
    badge: 'secondary',
    text: 'Warning'
  },
  error: {
    color: 'bg-red-500',
    badge: 'destructive',
    text: 'Error'
  },
  offline: {
    color: 'bg-gray-500',
    badge: 'outline',
    text: 'Offline'
  }
} as const;

export function SystemStatusCard({ service, status, uptime, responseTime }: SystemStatusCardProps) {
  const config = statusConfig[status];
  
  return (
    <Card className="hover:shadow-sm transition-shadow">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium">{service}</CardTitle>
          <div className="flex items-center gap-2">
            <div className={cn('w-2 h-2 rounded-full', config.color)} />
            <Badge variant={config.badge as any} className="text-xs">
              {config.text}
            </Badge>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-1 text-xs">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Uptime</span>
            <span className="font-mono">{uptime}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Response</span>
            <span className="font-mono">{responseTime}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}